<template>
<div class="wrap_advanced wow fadeInUp">
 <el-row>
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="5" class="header_block server_box" v-for="(item,index) in serviceArray"  :key="index">
        <img :src="item.url" class="server_img" />
        <p class="server_title">{{item.title}}</p>
        <!-- <p class="server_titleEng">{{item.titleEng}}</p> -->
  </el-col>
  <el-col :span="2" class="header_block"></el-col>
</el-row>
</div>


   <!-- <div class="wrap class-list clearfix wow fadeInUp">
                <ul class="clearfix">
                    <li class="li1 lines wow fadeInUp">
                        <div class="box">
                            <a href="/bussvideo/" target="_blank">
                                <p class="a1 a"></p>
                            </a>
                            <a href="/bussvideo/" target="_blank">
                                <p class="title">商业视频</p>
                                <p class="eng">Commercial video</p>
                            </a>
                        </div>
                    </li>
                    <li class="li2 lines wow fadeInUp">
                        <div class="box">
                            <a href="/shortvideo/" target="_blank">
                                <p class="a2 a"></p>
                            </a>
                            <a href="/shortvideo/" target="_blank">
                                <p class="title">短视频</p>
                                <p class="eng">short video</p>
                            </a>
                        </div>
                    </li>
                    <li class="li3 lines wow fadeInUp">
                        <div class="box">
                            <a href="/videocourse/" target="_blank">
                                <p class="a3 a"></p>
                            </a>
                            <a href="/videocourse/">
                                <p class="title">视频课程</p>
                                <p class="eng">video course</p>
                            </a>
                        </div>
                    </li>
                    <li class="li4  wow fadeInUp">
                        <div class="box">
                            <a href="/multimedia/" target="_blank">
                                <p class="a4 a"></p>
                            </a>
                            <a href="/multimedia/" target="_blank">
                                <p class="title">多媒体展示</p>
                                <p class="eng">multimedia show</p>
                            </a>
                        </div>
                    </li>
                </ul>
            </div> -->
</template>

<script>
export default {
  name: 'serviceAdvanced',
  // props: {
  //   serviceArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      serviceArray:[
        {url:require('@/assets/imgs/dsp01.png'),title:'专业内容团队',titleEng:'Commercial video'},
        {url:require('@/assets/imgs/dsp02.png'),title:'专业服务团队',titleEng:'short video'},
        {url:require('@/assets/imgs/dsp03.png'),title:'高效对接流程',titleEng:'video course'},
        {url:require('@/assets/imgs/dsp04.png'),title:'丰富行业经验',titleEng:'multimedia show'},
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },

  // mounted(){
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  // },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
	// 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
	// })
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_advanced{
  .header_block{
    min-height:10px
    }
  }
      .server_box{
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .server_img{
        // width: 50%;
        width:129px;
        height: 129px;
      }
      .server_title{
font-size: 22px;
    color: #363636;
    margin-top: 34px
}
.server_titleEng{
  font-size: 14px;
    color: #8d8d8d;
    margin-top: 8px;
}
  
}
</style>



